<div class="reco-buy-qty-status-bar">Plan Budget: {{ maxBudget | currency : 'USD' : 'symbol' : '1.0-2' }}</div>
